import React, { useEffect, useState, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import ProductService from "../../Services/products_service";
import { getFileUrl } from '../utils/fileUrl';
const toSubscript = (str) => {
  if (!str) return str;
  const subscriptMap = { 0: "₀", 1: "₁", 2: "₂", 3: "₃", 4: "₄", 5: "₅", 6: "₆", 7: "₇", 8: "₈", 9: "₉" };
  return str.replace(/[0-9]/g, (digit) => subscriptMap[digit] || digit);
};

const ProductDetailPage = () => {
  const navigate = useNavigate();
  const { catalogNumber } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");

  const imageRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);
  const [transformOrigin, setTransformOrigin] = useState("center center");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await ProductService.fetchProductDetailByCatalogNumber(catalogNumber);
        if (res.success) {
          setProduct(res.data);
        } else {
          setError(res.message);
          // Fallback to default product if the requested one fails
          const fallbackRes = await ProductService.fetchProductDetailByCatalogNumber("VL-A049010");
          if (fallbackRes.success) {
            setProduct(fallbackRes.data);
          } else {
            setError(fallbackRes.message || "Failed to load fallback product");
          }
        }
      } catch (err) {
        console.error("Error loading product:", err);
        setError(err.message || "Something went wrong while fetching product details");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [catalogNumber]);

  const handleMouseMove = (e) => {
    if (!imageRef.current) return;
    const rect = imageRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setTransformOrigin(`${x}% ${y}%`);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!product) return <p>No product found</p>;

  const molecularFormula = product.molF || product.molecularFormula || "N/A";
  const firstTwoLetters = product.name?.slice(0, 2).toLowerCase();
  const isAlpha = /^[a-z]{2}$/.test(firstTwoLetters);

  return (
    <>
      <div style={{ padding: "1rem", fontFamily: "Arial, sans-serif", backgroundColor: "#f9f9f9" }}>
        <div style={{ marginBottom: "1rem" }}>
          <div style={{ fontSize: "1.3rem", color: "#00659e" }}>
            <Link to={`/Products?query=${firstTwoLetters}`} style={{ marginRight: "5px" }}>
              Home /
            </Link>
            <Link to={`/Products?query=${firstTwoLetters}`} style={{ marginRight: "5px" }}>
              Products
            </Link>
            / <span>{product.name}</span>
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
          <div
    style={{
      position: "relative",
      padding: "1rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "auto",
      minWidth: "300px",
      minHeight: "300px",
      border: "1px solid #eee",
    }}
  >
    {product?.image ? (
      <>
        <img
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          onMouseMove={handleMouseMove}
          ref={imageRef}
          src={getFileUrl(product.image)}
          alt={product.name}
          style={{
            maxWidth: "100%",
            height: "auto",
            objectFit: "contain",
            display: "block",
          }}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />

        {isHovering && (
          <div
            style={{
              position: "absolute",
              left: "100%",
              width: "400px",
              height: "400px",
              border: "1px solid #ccc",
              backgroundImage: `url(${getFileUrl(product.image)})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: `${imageRef.current?.width * 2}px ${
                imageRef.current?.height * 2
              }px`,
              backgroundPosition: transformOrigin,
              boxShadow: "0 0 6px rgba(0,0,0,0.2)",
              zIndex: 20,
              backgroundColor: "#fff",
            }}
          />
        )}
      </>
    ) : (
      <div
        style={{
          color: "#999",
          fontSize: "16px",
          fontWeight: "500",
        }}
      >
        No Image 
      </div>
    )}
  </div>

          <div style={{ flex: 1, padding: "1rem", minWidth: "300px" }}>
            <h2 style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#333", marginBottom: "1rem" }}>
              {product.name}
            </h2>
            <div style={{ fontSize: "0.85rem", lineHeight: "1.4" }}>
              {[
                { label: "Catalog No", value: product.catalogNumber },
                { label: "CAS No", value: product.casNumber },
                { label: "Mol.F", value: toSubscript(molecularFormula) },
                { label: "Mol.W", value: `${product.molecularWeight} g/mol` },
               { 
  label: "Status", 
  value:
    !product.status || product.status === "UNKNOWN"
      ? "CUSTOM_SYNTHESIS"
      : product.status
},

                { label: "IUPAC Name", value: product.iupacName },
                { label: "SMILES", value: product.smiles },
                { label: "Shipping Temp", value: product.shippingTemperature },
                { label: "Country of Origin", value: product.countryOfOrigin },
              ].map((item, idx) => (
                <div key={idx} style={{ display: "flex", marginBottom: "0.4rem" }}>
                  <strong style={{ width: "35%", color: "#555", fontSize: "0.85rem", textAlign: "right" }}>{item.label}</strong>
                  <span style={{ margin: "0 35px", fontSize: "0.85rem" }}>:</span>
                  <span style={{ width: "75%", color: "#333", fontSize: "0.85rem" }}>{item.value}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: "1rem", textAlign: "right" }}>
              <button
                style={{
                  backgroundColor: "#2b6e73",
                  color: "#fff",
                  border: "none",
                  padding: "0.6rem 1.5rem",
                  fontSize: "1rem",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                }}
                onClick={() =>
                  navigate("/get-quote", {
                    state: {
                      name: product.name,
                      catalogNumber: product.catalogNumber,
                      casNumber: product.casNumber,
                      molecularFormula,
                      molecularWeight: product.molecularWeight,
                      iupacName: product.iupacName,
                      smiles: product.smiles,
                      shippingTemperature: product.shippingTemperature,
                      countryOfOrigin: product.countryOfOrigin,
                    },
                  })
                }
              >
                RFQ
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.tabWrapper}>
        <div style={styles.tabHeader}>
          {["overview", "description", "technical"].map((tab) => (
            <div
              key={tab}
              style={activeTab === tab ? styles.activeTab : styles.inactiveTab}
              onClick={() => setActiveTab(tab)}
            >
              {tab === "overview"
                ? "Product Overview"
                : tab === "description"
                ? "Description"
                : "Technical Data"}
            </div>
          ))}
        </div>

        <div style={styles.tabBox}>
          {activeTab === "overview" && (
            <div style={styles.tabContent}>
              {[
                { label: "Chemical Name", value: product.name },
                { label: "Synonym", value: product.synonym || "N/A" },
                { label: "Mol.F", value: toSubscript(molecularFormula) },
                { label: "Mol.W",  value: `${product.molecularWeight} g/mol`  || "N/A" },
                {
                  label: "Shipping Temperature",
                  value: product.shippingTemperature,
                },
                { label: "HSN Code", value: product.hsnCode || "N/A" },
                { label: "Country of Origin", value: product.countryOfOrigin },
                { label: "Smiles", value: product.smiles },
              ].map((item, index) => (
                <div style={styles.tabRow} key={index}>
                  <span style={styles.tabLabel}>{item.label}</span>
                  <span style={styles.tabColon}>:</span>
                  <span style={styles.tabValue}>{item.value}</span>
                </div>
              ))}
            </div>
          )}
          {activeTab === "description" && (
            <p style={styles.tabDescription}>{product.description}</p>
          )}
          {activeTab === "technical" && (
            <p style={styles.tabDescription}>
              {product.technicalData && product.technicalData.trim() !== ""
                ? product.technicalData
                : "No Information"}
            </p>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

const styles = {
  container: {
    padding: "1rem",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f9f9f9",
  },
  header: {
    marginBottom: "1rem",
  },
  breadcrumb: {
    fontSize: "1.3rem",
    display: "flex",
    flexWrap: "wrap",
    color: "#00659e",
    paddingTop: "0px",
    "@media (max-width: 768px)": {
      fontSize: "0.9rem",
      paddingTop: "40px",
    },
  },
  breadcrumbLink: {
    color: "#00659e",
    textDecoration: "none",
    marginRight: "5px",
  },
  card: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    marginTop: "1rem",
    flexWrap: "wrap",
    height: "auto",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  imageSection: {
    backgroundColor: "#f2f2f2",
    display: "contents",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
    width: "30%",
    maxHeight: "300px",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      width: "100%",
      maxHeight: "200px",
      backgroundColor: "#4E4D4DFF",
    },
  },
  zoomWindow: {
    position: "absolute",
    top: 0,
    left: "110%",
    width: "580px",
    height: "500px",
    backgroundColor: "#fff",
    border: "2px solid #ccc",
    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
    zIndex: 10,
    borderRadius: "1%",
    marginLeft: "-40px",
    "@media (max-width: 768px)": {
      left: 0,
      top: "110%",
      width: "150px",
      height: "150px",
    },
  },
  details: {
    flex: 1,
    padding: "1rem",
    paddingTop: "0.5rem",
    width: "70%",
    boxSizing: "border-box",
    position: "relative",
    color: "black",
    "@media (max-width: 768px)": {
      width: "100%",
      paddingTop: "0.3rem",
    },
  },
  productName: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "0rem",
    lineHeight: "1.2",
    "@media (max-width: 768px)": {
      fontSize: "1.2rem",
    },
  },
  table: {
    width: "100%",
    fontSize: "0.95rem",
    lineHeight: "1.4",
    marginTop: "0rem",
    "@media (max-width: 768px)": {
      fontSize: "0.85rem",
    },
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexWrap: "wrap",
  },
  labelCell: {
    width: "35%",
    padding: "0.3rem 0",
    textAlign: "right",
    paddingRight: "0.5rem",
    color: "#555",
    fontWeight: "600",
    "@media (max-width: 768px)": {
      width: "100%",
      textAlign: "left",
      paddingRight: "0",
    },
  },
  colonCell: {
    width: "5%",
    textAlign: "center",
    padding: "0.3rem 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#555",
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  valueCell: {
    width: "60%",
    padding: "0.3rem 0",
    textAlign: "left",
    paddingLeft: "0.5rem",
    whiteSpace: "normal",
    color: "#333",
    "@media (max-width: 768px)": {
      width: "100%",
      paddingLeft: "0",
      marginBottom: "0.5rem",
    },
  },
  rfqButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "1rem",
    "@media (max-width: 768px)": {
      justifyContent: "center",
    },
  },
  rfqButton: {
    backgroundColor: "#2b6e73",
    color: "#fff",
    border: "none",
    padding: "0.6rem 1.5rem",
    fontSize: "1rem",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    transition: "background-color 0.3s ease",
    "@media (max-width: 768px)": {
      padding: "0.5rem 1rem",
      fontSize: "0.9rem",
    },
  },
  tabWrapper: {
    marginTop: "1.5rem",
    paddingInline: "1rem",
  },
  tabHeader: {
    display: "flex",
    gap: "0.3rem",
    marginBottom: "-1px",
    overflowX: "auto",
    whiteSpace: "nowrap",
    "@media (max-width: 768px)": {
      flexWrap: "wrap",
    },
  },
  activeTab: {
    backgroundColor: "#2b6e73",
    color: "#fff",
    padding: "0.5rem 1rem",
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: "5px 5px 0 0",
    "@media (max-width: 768px)": {
      padding: "0.4rem 0.8rem",
      fontSize: "0.9rem",
    },
  },
  inactiveTab: {
    backgroundColor: "#ccc",
    color: "#333",
    padding: "0.5rem 1rem",
    cursor: "pointer",
    borderRadius: "5px 5px 0 0",
    "@media (max-width: 768px)": {
      padding: "0.4rem 0.8rem",
      fontSize: "0.9rem",
    },
  },
  tabBox: {
    backgroundColor: "#f2f2f2",
    color: "#000",
    lineHeight: "1.5",
    padding: "1.5rem",
    borderRadius: "0 0 8px 8px",
    marginBottom: "55px",
  },
  tabContent: {
    display: "flex",
    flexDirection: "column",
    gap: "0.3rem",
    marginLeft: "0",
    width: "100%",
    boxSizing: "border-box",
  },
  tabRow: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    marginBottom: "0.2rem",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  tabLabel: {
    width: "20%",
    textAlign: "right",
    color: "#333",
    fontWeight: "bold",
    paddingRight: "1rem",
    fontSize: "1rem",
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
    "@media (max-width: 768px)": {
      width: "100%",
      textAlign: "left",
      paddingRight: "0",
      fontSize: "0.85rem",
      marginBottom: "0.1rem",
    },
  },
  tabColon: {
    width: "5%",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    fontSize: "1rem",
    color: "#333",
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  tabValue: {
    width: "75%",
    textAlign: "left",
    paddingLeft: "1rem",
    whiteSpace: "normal",
    fontSize: "1rem",
    color: "#333",
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
    "@media (max-width: 768px)": {
      width: "100%",
      paddingLeft: "0",
      fontSize: "0.85rem",
    },
  },
  tabDescription: {
    marginTop: "0.5rem",
    fontSize: "1rem",
    lineHeight: "1.6",
    color: "#333",
    "@media (max-width: 768px)": {
      fontSize: "0.85rem",
    },
  },
};

export default ProductDetailPage;